import * as angular from 'angular';
import { getCognitoToken } from 'angular/utils/cognito';
import * as moment from 'moment';
import { AuthService } from 'app/_services/auth.service';

(function () {
    'use strict';

    angular.module('formular').controller('FormularCtrl', FormularCtrl);

    function FormularCtrl(authService: AuthService, Auth, $rootScope) {
        // this will be used in `angular/src/main/webapp/app/app.route.ts`
        $rootScope.checkAuth = async function checkAuth() {
            // as the `/rest/auth` resource would return 204 instead of 401
            // when the user is not authenticated, we need to update the
            // cognito token before calling the resource to have a consistent
            // behavior
            await getCognitoToken();

            Auth.get(
                undefined,
                async function (res) {
                    if (
                        angular.isDefined(res) &&
                        angular.isDefined(res.email) &&
                        res.email !== null
                    ) {
                        if (res.trackingSettings && res.trackingSettings.date) {
                            res.trackingSettings.date = moment(
                                res.trackingSettings.date
                            ).toDate();
                        }

                        authService.userLoginPromise.resolve(res);
                        authService.logIn(res);
                    } else {
                        authService.userLoginPromise.reject();
                        authService.logOut();
                    }
                },
                function () {
                    authService.userLoginPromise.reject();
                    authService.logOut();
                }
            );
        };
        $rootScope.checkAuth();
    }
})();
